import { render, staticRenderFns } from "./Approvals.vue?vue&type=template&id=6b509ad4&"
import script from "./Approvals.vue?vue&type=script&lang=js&"
export * from "./Approvals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports